import styles from "../sidePanel/constructionCalculationsPanel.module.scss";
import bodyStyles from "./constructionCalculationsBody.module.scss";

import type MastResultDto from "../../../../dto/calculations/MastResultDto";
import type ConstructionCalculationNewBodyProps from "./ConstructionCalculationsNewBodyProps";
import { Stack } from "@fluentui/react";
import IsaacEmpty from "../../../../components/isaacEmpty/IsaacEmpty";
import CalculationMastTabsNew from "../tabs/CalculationMastTabsNew";
import CalculationMastResultsNew from "../mastResults/CalculationMastResultsNew";
import MastProfileAndFoundationPanelNew from "../panelMastProfileAndFoundation/MastProfileAndFoundationPanelNew";
import EditedPropertiesPanelNew from "../panelEditedProperties/EditedPropertiesPanelNew";
import DeselectedElementsPanelNew from "../panelDeselectedElementsPanel/DeselectedElementsPanelNew";


const ConstructionCalculationsNewBody: React.FunctionComponent<ConstructionCalculationNewBodyProps> = ({
    selectedMastNo,
    construction,
    constructionDetails,
    calculationResults
}) => {
    const mastResults = calculationResults?.mastResults?.find((mr: MastResultDto) => mr.mastNo === selectedMastNo);

     return (
        <div className={styles.resultsAndPanels}>
            {mastResults !== undefined ? (
                <div className={`${styles.pageBrakeAvoid}`}>
                <Stack className={styles.resultTabs}>
                    <h3 className={`${bodyStyles.resultsHeader} ${bodyStyles.noPrint}`}>
                        Results
                    </h3>
                    <div className={styles.resultNavigation}>
                    {construction && (
                        <CalculationMastTabsNew
                            construction={construction}
                            calculationResults={calculationResults}
                            selectedMastNo={selectedMastNo}
                        />
                    )}
                    </div>
                </Stack>
                <Stack
                    className={`${styles.resultContainer} ${styles.pageBrakeAvoid}`}
                    horizontal
                    wrap>
                    <CalculationMastResultsNew mastResults={mastResults} />
                    <Stack grow={3} className={styles.panelsContainer}>
                        <MastProfileAndFoundationPanelNew
                            constructionDetails={constructionDetails}
                            selectedMastNo={selectedMastNo}
                            calculationResults={calculationResults}
                        />
                        <EditedPropertiesPanelNew
                            construction={construction}
                            calculationResults={calculationResults}
                        />
                        <DeselectedElementsPanelNew
                            construction={construction}
                            calculationResults={calculationResults}
                        />
                    </Stack>
                </Stack>
                </div>
            ) : (
                <IsaacEmpty message="No data to show for the current calculation." />
            )}
        </div>
  );
};

export default ConstructionCalculationsNewBody;